export enum EWorkShopDetailsTabsUrl {
  DETAILS = 'details',
  CHILD_CARE = 'cildcare',
  WAITLIST = 'waitlist',
  QUESTION = 'question',
  REGISTRANTS = 'registrants',
  ATTENDANCE = 'attendance',
  NOTES = 'notes',
  KITS = 'kits',
  OUTPUT = 'output',
}
